import { render, staticRenderFns } from "./GameName.vue?vue&type=template&id=4850d822&scoped=true"
import script from "./GameName.vue?vue&type=script&lang=js"
export * from "./GameName.vue?vue&type=script&lang=js"
import style0 from "./GameName.vue?vue&type=style&index=0&id=4850d822&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4850d822",
  null
  
)

export default component.exports